module.exports = __webpack_public_path__ + "img/color.b699f377.svg";